/* eslint-disable import/extensions */
import React from 'react';

// Icons
import {
  ServiceIcon,
  TrainingIcon,
  SparepartIcon,
  MillingIcon,
  LaserIcon,
  LatheIcon,
  RouterIcon,
  PlasmaIcon,
  EdmIcon,
  GrindingIcon,
  BendingIcon,
  StepperIcon,
  LensIcon,
} from '../parts/Icons';

// Advantages - Using SVG icons for better performance
import ExperiencedTechnician from '../assets/images/Advantages/ExperiencedTechnician.svg';
import FastResponse from '../assets/images/Advantages/FastResponse.svg';
import CompetitivePrice from '../assets/images/Advantages/CompetitivePrice.svg';
import Support24H from '../assets/images/Advantages/Support24H.svg';

const IconClass = "w-24 h-24 text-theme-blue group-hover:text-theme-purple transition-colors duration-300";

export const Services = [
  {
    title: 'Jasa Servis CNC',
    icon: <ServiceIcon className={IconClass} />,
    animation: 'left',
  },
  {
    title: 'Training Operator',
    icon: <TrainingIcon className={IconClass} />,
    animation: 'up',
  },
  {
    title: 'Sparepart & Upgrade',
    icon: <SparepartIcon className={IconClass} />,
    animation: 'right',
  },
];

export const Portfolios = [
  {
    id: 'sales-1',
    title: 'Mesin CNC Milling 3 Axis',
    icon: <MillingIcon className={IconClass} />,
    type: 'Penjualan',
    responsibility: [
      'Spesifikasi Tinggi',
      'Garansi Resmi',
    ],
    credit: '',
  },
  {
    id: 'sales-2',
    title: 'Mesin Laser CO2',
    icon: <LaserIcon className={IconClass} />,
    type: 'Penjualan',
    responsibility: [
      'Presisi Tinggi',
      'After Sales Service',
    ],
    credit: '',
  },
  {
    id: 'sales-3',
    title: 'Mesin CNC Turning (Bubut)',
    icon: <LatheIcon className={IconClass} />,
    type: 'Penjualan',
    responsibility: [
      'Akurasi Tinggi',
      'Hemat Energi',
    ],
    credit: '',
  },
  {
    id: 'sales-4',
    title: 'Mesin CNC Router',
    icon: <RouterIcon className={IconClass} />,
    type: 'Penjualan',
    responsibility: [
      'Area Kerja Luas',
      'Kecepatan Optimal',
    ],
    credit: '',
  },
  {
    id: 'sales-5',
    title: 'Mesin CNC Plasma Cutting',
    icon: <PlasmaIcon className={IconClass} />,
    type: 'Penjualan',
    responsibility: [
      'Cutting Cepat',
      'Multi Material',
    ],
    credit: '',
  },
  {
    id: 'sales-6',
    title: 'Mesin EDM (Electrical Discharge)',
    icon: <EdmIcon className={IconClass} />,
    type: 'Penjualan',
    responsibility: [
      'Presisi Mikron',
      'Kompleks Detail',
    ],
    credit: '',
  },
  {
    id: 'sales-7',
    title: 'Mesin CNC Grinding',
    icon: <GrindingIcon className={IconClass} />,
    type: 'Penjualan',
    responsibility: [
      'Finishing Halus',
      'Toleransi Ketat',
    ],
    credit: '',
  },
  {
    id: 'sales-8',
    title: 'Mesin CNC Bending (Press Brake)',
    icon: <BendingIcon className={IconClass} />,
    type: 'Penjualan',
    responsibility: [
      'Presisi Bending',
      'Kontrol Digital',
    ],
    credit: '',
  },
  {
    id: 'training-1',
    title: 'Training Operator CNC Dasar',
    icon: <TrainingIcon className={IconClass} />,
    type: 'Training',
    responsibility: [
      'Pengenalan Mesin',
      'G-Code Dasar',
    ],
    credit: '',
  },
  {
    id: 'training-2',
    title: 'Training Maintenance Mandiri',
    icon: <ServiceIcon className={IconClass} />,
    type: 'Training',
    responsibility: [
      'Perawatan Harian',
      'Troubleshooting Ringan',
    ],
    credit: '',
  },
  {
    id: 'service-1',
    title: 'Service Mesin CNC Milling 3 Axis',
    icon: <MillingIcon className={IconClass} />,
    type: 'Service',
    responsibility: [
      'Perbaikan Mekanik',
      'Kalibrasi Akurasi',
    ],
    credit: '',
  },
  {
    id: 'service-2',
    title: 'Service Mesin CNC Turning (Bubut)',
    icon: <LatheIcon className={IconClass} />,
    type: 'Service',
    responsibility: [
      'Alignment Turret',
      'Perbaikan Chuck',
    ],
    credit: '',
  },
  {
    id: 'service-3',
    title: 'Service Mesin CNC Router',
    icon: <RouterIcon className={IconClass} />,
    type: 'Service',
    responsibility: [
      'Ganti Spindle',
      'Setting Inverter',
    ],
    credit: '',
  },
  {
    id: 'service-4',
    title: 'Service Mesin Laser CO2',
    icon: <LaserIcon className={IconClass} />,
    type: 'Service',
    responsibility: [
      'Ganti Tabung Laser',
      'Setting Optik',
    ],
    credit: '',
  },
  {
    id: 'service-5',
    title: 'Service Mesin CNC Plasma Cutting',
    icon: <PlasmaIcon className={IconClass} />,
    type: 'Service',
    responsibility: [
      'Perbaikan Torch',
      'Setting THC',
    ],
    credit: '',
  },
  {
    id: 'service-6',
    title: 'Service Mesin EDM (Electrical Discharge)',
    icon: <EdmIcon className={IconClass} />,
    type: 'Service',
    responsibility: [
      'Perbaikan Generator',
      'Flushing System',
    ],
    credit: '',
  },
  {
    id: 'service-7',
    title: 'Service Mesin CNC Grinding',
    icon: <GrindingIcon className={IconClass} />,
    type: 'Service',
    responsibility: [
      'Dressing Spindle',
      'Balancing Batu',
    ],
    credit: '',
  },
  {
    id: 'service-8',
    title: 'Service Mesin CNC Bending (Press Brake)',
    icon: <BendingIcon className={IconClass} />,
    type: 'Service',
    responsibility: [
      'Perbaikan Hidrolik',
      'Setting Backgauge',
    ],
    credit: '',
  },
  {
    id: 'sparepart-1',
    title: 'Stepper Motor Nema 23',
    icon: <StepperIcon className={IconClass} />,
    type: 'Sparepart',
    responsibility: [
      'High Torque',
      'Original',
    ],
    credit: '',
  },
  {
    id: 'sparepart-2',
    title: 'Lensa Laser CO2 Focus',
    icon: <LensIcon className={IconClass} />,
    type: 'Sparepart',
    responsibility: [
      'High Quality',
      'Tahan Lama',
    ],
    credit: '',
  },
];

export const Advantages = [
  [{
    title: 'Teknisi Berpengalaman',
    description: 'Tim teknisi kami memiliki pengalaman lebih dari 10 tahun dalam menangani berbagai jenis mesin CNC dan Laser CO2 dari berbagai brand.',
    imageUrl: ExperiencedTechnician,
  },
  {
    title: 'Dukungan 24/7',
    description: 'Tim support kami siap membantu Anda kapan saja. Konsultasi gratis untuk troubleshooting dan pertanyaan teknis seputar mesin CNC.',
    imageUrl: Support24H,
  }],
  [{
    title: 'Respon Cepat',
    description: 'Kami siap merespon kebutuhan Anda dalam waktu kurang dari 24 jam. Untuk kerusakan urgent, teknisi kami bisa datang di hari yang sama.',
    imageUrl: FastResponse,
  },
  {
    title: 'Harga Kompetitif',
    description: 'Harga transparan tanpa biaya tersembunyi. Kami memberikan penawaran terbaik dengan kualitas kerja yang tidak diragukan.',
    imageUrl: CompetitivePrice,
  }],
];

// Featured Portfolio - 2 items each for Sales, Service, and Sparepart
export const FeaturedPortfolio = [
  // Featured Sales (2 items)
  {
    id: 'sales-1',
    title: 'Mesin CNC Milling 3 Axis',
    icon: <MillingIcon className={IconClass} />,
    type: 'Penjualan',
    responsibility: [
      'Spesifikasi Tinggi',
      'Garansi Resmi',
    ],
    credit: '',
  },
  {
    id: 'sales-2',
    title: 'Mesin Laser CO2',
    icon: <LaserIcon className={IconClass} />,
    type: 'Penjualan',
    responsibility: [
      'Presisi Tinggi',
      'After Sales Service',
    ],
    credit: '',
  },
  // Featured Service (2 items)
  {
    id: 'service-1',
    title: 'Service Mesin CNC Milling 3 Axis',
    icon: <MillingIcon className={IconClass} />,
    type: 'Service',
    responsibility: [
      'Perbaikan Mekanik',
      'Kalibrasi Akurasi',
    ],
    credit: '',
  },
  {
    id: 'service-4',
    title: 'Service Mesin Laser CO2',
    icon: <LaserIcon className={IconClass} />,
    type: 'Service',
    responsibility: [
      'Ganti Tabung Laser',
      'Setting Optik',
    ],
    credit: '',
  },
  // Featured Sparepart (2 items)
  {
    id: 'sparepart-1',
    title: 'Stepper Motor Nema 23',
    icon: <StepperIcon className={IconClass} />,
    type: 'Sparepart',
    responsibility: [
      'High Torque',
      'Original',
    ],
    credit: '',
  },
  {
    id: 'sparepart-2',
    title: 'Lensa Laser CO2 Focus',
    icon: <LensIcon className={IconClass} />,
    type: 'Sparepart',
    responsibility: [
      'High Quality',
      'Tahan Lama',
    ],
    credit: '',
  },
];

export const landingPage = {
  service: Services,
  portfolio: FeaturedPortfolio,
  advantage: Advantages,
};
